import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { computed, ref, watch, CSSProperties } from 'vue';
import { useRoute } from 'vue-router';
import MainNavigationHandler from '@/shared/navigation/site-navigation/MainNavigationHandler.vue';
import MenuItems from './MenuItems.vue';
import navigationStore from '@/shared/navigation/navigation.store';
import pageStore from '@/shared/content/page.store';
import DrawerDialog from '@/shared/dialog/DrawerDialog.vue';
import navigationTrackingService from '@/shared/tracking/navigation-tracking.service';


export default /*#__PURE__*/_defineComponent({
  __name: 'DesktopPageHeader',
  setup(__props) {

const route = useRoute();
const showMainNavigation = ref(false);
const focusedMenuItemElement = ref<HTMLElement | undefined>(undefined);

const activeMainNavigationItem = computed(() => {
    return (
        navigationStore.hasActiveSearch ||
        navigationStore.hasActiveBasket ||
        navigationStore.activeMainNavigationItem
    );
});

const clickedClose = (): void => {
    navigationTrackingService.menuItem(null);
    onNavigationClose();
};

const onNavigationClose = (): void => {
    navigationStore.clearActiveMainNavigation();
};

function setFocusedElement(element) {
    focusedMenuItemElement.value = element;
}

const topBannerBarOffsetStyling = computed<CSSProperties>(() => {
    // Offset styling for menu-dialog
    return { 'margin-top': `${pageStore.topNavigationHeight}px` };
});

watch(() => route.path, onNavigationClose);

watch(
    activeMainNavigationItem,
    (activeItem, previousActiveItem) => {
        showMainNavigation.value = !!(
            activeItem && activeItem !== previousActiveItem
        );
    },
    { immediate: true },
);


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("header", null, [
    _createVNode(MenuItems, {
      "aria-hidden": showMainNavigation.value,
      class: "z-51 relative bg-white",
      "show-main-navigation": showMainNavigation.value,
      onItemActive: setFocusedElement
    }, null, 8, ["aria-hidden", "show-main-navigation"]),
    _createVNode(DrawerDialog, {
      "is-open": showMainNavigation.value,
      "onUpdate:is-open": _cache[0] || (_cache[0] = ($event: any) => ((showMainNavigation).value = $event)),
      position: "navigation",
      "show-close-button": false,
      style: _normalizeStyle(_unref(topBannerBarOffsetStyling)),
      "initial-focus-element": focusedMenuItemElement.value,
      onClose: clickedClose
    }, {
      default: _withCtx(() => [
        _createElementVNode("header", null, [
          _createVNode(MenuItems, {
            "aria-hidden": !showMainNavigation.value,
            class: "z-51 relative",
            "show-main-navigation": showMainNavigation.value
          }, null, 8, ["aria-hidden", "show-main-navigation"])
        ]),
        _createVNode(MainNavigationHandler)
      ]),
      _: 1
    }, 8, ["is-open", "style", "initial-focus-element"])
  ]))
}
}

})